module.exports = __webpack_public_path__ + "static/media/Wiz.0523a885.png";